/** API Village ↔ UI village master fields. */

export function villageFromApi(row) {
  if (!row) return null;
  return {
    id: row.id,
    villageId: row.code ?? '',
    villageName: row.name ?? '',
    talukaName: row.talukaName ?? '',
    district: row.district ?? '',
    state: row.state ?? '',
    country: row.country ?? '',
    gramPanchayat: row.gramPanchayat ?? '',
    pin: row.pin ?? '',
    category: row.category ?? '',
    latitude: row.latitude != null ? Number(row.latitude) : null,
    longitude: row.longitude != null ? Number(row.longitude) : null,
    boundary: row.boundary ?? null,
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function villageToApi(ui) {
  if (!ui) return null;
  const body = {
    name: ui.villageName,
    talukaName: ui.talukaName || null,
    district: ui.district || null,
    state: ui.state || null,
    country: ui.country || null,
    gramPanchayat: ui.gramPanchayat || null,
    pin: ui.pin || null,
    category: ui.category || null,
    latitude: ui.latitude != null && ui.latitude !== '' ? Number(ui.latitude) : null,
    longitude: ui.longitude != null && ui.longitude !== '' ? Number(ui.longitude) : null,
    boundary: ui.boundary ?? null,
    isActive: ui.active !== false,
  };
  if (ui.code) body.code = ui.code;
  return body;
}
